import React from "react";
import { IonModal } from "@ionic/react";
import { freeProgramStartLabel } from "../../services/freeProgramOffer";
import "./CtaBar.css";

/**
 * The confirmation before a FREE enrolment is cancelled. It says what the member
 * actually loses (client, 18/09):
 *  - the program is running (the trial strip in the course pages): its
 *    contents and chat;
 *  - it hasn't started (`upcomingStart`, "YYYY-MM-DD": the strip above the tab
 *    bar, the Free Programme screen): the member is still a Guest, so only the
 *    booking, and they can pick one of the next dates again.
 * The buttons name the action ("Indietro" / "Annulla …"): "Annulla / Conferma"
 * read both ways.
 */
const CancelTrialConfirmModal = ({ isOpen, onClose, onConfirm, upcomingStart }) => (
  <IonModal
    isOpen={isOpen}
    onDidDismiss={onClose}
    className="cta-cancel-confirm-modal"
  >
    <div className="cta-cancel-confirm">
      <div className="cta-cancel-confirm__icon" aria-hidden="true">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <path
            d="M29.07 8.82L4.12 51.18A3.5 3.5 0 007.05 56.5h49.9a3.5 3.5 0 002.93-5.32L34.93 8.82a3.5 3.5 0 00-5.86 0z"
            fill="#FACC15"
            stroke="#EAB308"
            strokeWidth="2"
          />
          <text
            x="32"
            y="44"
            textAnchor="middle"
            fontSize="30"
            fontWeight="bold"
            fill="#78350F"
          >
            !
          </text>
        </svg>
      </div>

      <h2 className="cta-cancel-confirm__title">
        {upcomingStart
          ? "Vuoi annullare la tua iscrizione?"
          : "Vuoi annullare la tua prova gratuita?"}
      </h2>

      <p className="cta-cancel-confirm__body">
        {upcomingStart
          ? `Hai prenotato il percorso FREE che inizia ${freeProgramStartLabel(
              upcomingStart,
            )}. Se annulli, potrai scegliere nuovamente una delle prossime date disponibili.`
          : "Annullando perderai l'accesso ai contenuti e alla chat dedicata al percorso gratuito."}
      </p>

      <div className="cta-cancel-confirm__buttons">
        <button
          className="cta-cancel-confirm__btn cta-cancel-confirm__btn--outline"
          onClick={onClose}
        >
          Indietro
        </button>
        <button
          className="cta-cancel-confirm__btn cta-cancel-confirm__btn--confirm"
          onClick={() => {
            onClose();
            if (onConfirm) onConfirm();
          }}
        >
          {upcomingStart ? "Annulla iscrizione" : "Annulla prova"}
        </button>
      </div>
    </div>
  </IonModal>
);

export default CancelTrialConfirmModal;
